import { Component, OnInit } from '@angular/core';

import { IndexFieldComponent } from './index-field.component';

@Component({
  selector: 'app-auto-index-field-component',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class AutoIndexFieldComponent extends IndexFieldComponent implements OnInit {

  ngOnInit() {
    this.locked = true;
    super.ngOnInit();
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/auto-index-field.component.ts